module.exports = __webpack_public_path__ + "fec93d119024cd0b24c176c835a6af70.pdf";